import { HttpErrorResponse } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, delay, map, of, switchMap, tap } from 'rxjs'
import { AppErrorHandlerService } from '../../services/app-error-handler/app-error-handler.service'
import { LogService } from '../../services/log.service'
import { UtilityService } from '../../services/utility.service'
import * as FeaturePDActions from './feature-pd.actions'
import { FeaturePDService } from './feature-pd.service'

@Injectable()
export class FeaturePDEffects {
   private _cn = this.constructor.name
   private _actions$ = inject(Actions)
   private _logService = inject(LogService)
   private _service = inject(FeaturePDService)
   private _utilityService = inject(UtilityService)
   private _errorHandlerService = inject(AppErrorHandlerService)

   retriveProject$ = createEffect(() =>
      this._actions$.pipe(
         ofType(FeaturePDActions.retriveProject),
         switchMap((action) =>
            this._service.getProjectById(action.id, action.status).pipe(
               tap((res) => this._logService.debug(this._cn, 'load project effect', 'response:', res)),
               delay(200),
               map((result) => FeaturePDActions.retriveProjectSuccess({ result })),
               catchError((error: HttpErrorResponse) => {
                  return of(FeaturePDActions.retriveProjectFailure({ error: error }))
               })
            )
         )
      )
   )

   retriveProjectConsortium$ = createEffect(() =>
      this._actions$.pipe(
         ofType(FeaturePDActions.retriveProjectConsortium),
         switchMap((action) =>
            this._service.retriveProjectConsortium(action.id).pipe(
               tap((res) => this._logService.debug(this._cn, 'load project consortium', 'response:', res)),
               map((result) => FeaturePDActions.retriveProjectConsortiumSuccess({ result })),
               catchError((error: HttpErrorResponse) => {
                  return of(FeaturePDActions.retriveProjectConsortiumFailure({ error: error }))
               })
            )
         )
      )
   )

   retriveProjectFinalProposals$ = createEffect(() =>
      this._actions$.pipe(
         ofType(FeaturePDActions.retriveProjectFinalProposals),
         switchMap((action) =>
            this._service.retriveProjectProposals(action.id).pipe(
               tap((res) => this._logService.debug(this._cn, 'load project final proposals', 'response:', res)),
               map((result) => FeaturePDActions.retriveProjectFinalProposalsSuccess({ result })),
               catchError((error: HttpErrorResponse) => {
                  return of(FeaturePDActions.retriveProjectFinalProposalsFailure({ error: error }))
               })
            )
         )
      )
   )

   downloadFinalProposal$ = createEffect(() =>
      this._actions$.pipe(
         ofType(FeaturePDActions.downloadFinalProposal),
         switchMap((action) =>
            this._service.downloadFinalProposal(action.projectId, action.fileId).pipe(
               tap((res) => this._logService.debug(this._cn, 'downloadFinalProposal effect', 'response:', res)),
               map((response) => {
                  if (response.body) {
                     this._utilityService.downloadFile(response)
                     return FeaturePDActions.downloadFinalProposalSuccess()
                  } else {
                     return FeaturePDActions.downloadFinalProposalFailure({ error: new HttpErrorResponse({ error: '0 - No blob in response to download' }) })
                  }
               }),

               catchError((error: HttpErrorResponse) => {
                  return of(FeaturePDActions.downloadFinalProposalFailure({ error: error }))
               })
            )
         )
      )
   )

   private _actionsForErrorNotificationMessage = [FeaturePDActions.retriveProjectFailure, FeaturePDActions.downloadFinalProposalFailure]

   listenAllFailureAction$ = createEffect(
      () =>
         this._actions$.pipe(
            ofType(...this._actionsForErrorNotificationMessage),
            map((errorResponse) => this._errorHandlerService.handleError(errorResponse.error))
         ),
      { dispatch: false }
   )
}
